The scheme ID of the location dataset to query.

Currently, only `seekAnz` and `seekAnzPublicTest` are supported.
